import intl from 'react-intl-universal';

// 添加需要支持的语言
export const locales = {
    'en-US': require('./locales/en-US.json'),
    'in-YN': require('./locales/in-YN.json'),
    // 可以添加更多语言
  };
  

  
  export default intl;